import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import radioFill from './images/radio-fill.svg';
import radioEmpty from './images/radio-empty.svg';
import radioDisabled from './images/radio-disabled.svg';

function SelectOptionButton(props) {
  const [buttonsData, setButtons] = useState(props.buttonsData);

  useEffect(() => {
    setButtons(props.buttonsData);
  }, [props.buttonsData]);

  function manageSelectedType(value) {
    let newData = props.buttonsData.map((button) => {
      if (button.value === value) {
        button.selected = true;
      } else {
        button.selected = false;
      }
      return button;
    });
    setButtons(newData);
    if (props.onClick != undefined) {
      props.onClick(value);
    }
  }
  function manageSubSelectedType(value, subButtonValue) {
    let newData = buttonsData.map((button) => {
      if (button.value === value) {
        button.subSelectingData.map((subButton) => {
          if (subButton.value === subButtonValue) {
            subButton.selected = true;
          } else {
            subButton.selected = false;
          }
          return subButton;
        });
      }
      return button;
    });
    setButtons(newData);
    if (props.onSubButtonClick != undefined) {
      props.onSubButtonClick(value, subButtonValue);
    }
  }

  return (
    <div className={`select-option-button-container`}>
      {props.title && <div className='select-option-button-title'>{props.title}</div>}
      {buttonsData.map((button, index) => {
        return (
          <div key={index}>
            <button
              className={`select-option-button ${button.selected ? 'selected' : ''} ${
                index == buttonsData.length - 1 ? 'last-child' : ''
              } ${button.disabled ? 'disabled' : ''}`}
              onClick={() => (button.disabled ? null : manageSelectedType(button.value))}>
              <div className={`${button.showRadioButtons ? 'd-flex' : ''}`}>
                <div className='select-option-radio-button'>
                  {button.showRadioButtons && button.disabled && <Image src={radioDisabled} alt='radio-button' />}
                  {button.showRadioButtons && !button.disabled && <Image src={button.selected ? radioFill : radioEmpty} alt='radio-button' />}
                </div>
                <div className='select-option-button-text' dangerouslySetInnerHTML={{__html: button.label}}></div>
              </div>
              <div className='select-option-button-right-content-container'>
                {button.rightContent && (
                  <span className='select-option-button-right-content' dangerouslySetInnerHTML={{__html: button.rightContent}}></span>
                )}
              </div>
            </button>
            {button.openComponent && button.selected && button.openComponent()}
            {button.subSelecting && button.selected && (
              <div className='select-option-button-sub-selecting'>
                {button.subSelectingData.map((subButton, index) => {
                  return (
                    <div key={index}>
                      <button
                        className={`select-option-button sub-selecting ${subButton.selected ? 'selected' : ''} ${
                          index == button.subSelectingData.length - 1 ? 'last-child' : ''
                        }`}
                        onClick={() => manageSubSelectedType(button.value, subButton.value)}>
                        <span className='select-option-button-text' dangerouslySetInnerHTML={{__html: subButton.label}}></span>

                        {subButton.rightContent && (
                          <span
                            className='select-option-button-right-content'
                            dangerouslySetInnerHTML={{__html: subButton.rightContent}}></span>
                        )}
                      </button>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default SelectOptionButton;
